<style lang="less" scoped>
.wzsm{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;margin-bottom: 30px;}
.center{display: flex;flex-direction: column;width: 1200px; margin: auto;}
.text{width: 1000px;margin: auto;}
h2{margin: 40px auto;}
p{text-indent: 2em;line-height: 40px;font-size: 18px; text-align: justify}
.kslj{height:260px;margin: 0px; margin-top: 0px;
  h3{line-height: 60px;text-align: left;color: #08032b;margin-left: 10px;}
  .links{display: flex;flex-wrap:wrap;width: 1200px;padding: 0;list-style: none;
    li{margin: 20px 10px;}
  }
}
</style>

<template>
  <div class="wzsm">
    <div class="center">
      <div class="text">
        <h2>网站声明</h2>
        <p>东盟矿业信息服务平台（中国—东盟矿业合作论坛官方网站）所涉及的任何资料的版权均属服务平台和资料提供者所有。</p>
        <p>1、本网站凡注明“来源:东盟矿业信息服务平台”的所有作品，未经东盟矿业信息服务平台书面授权，任何媒体、网站或个人不得转载、链接、摘编或利用其它方式使用上述作品。已经本网站协议授权的媒体或网站，应在授权范围内使用上述作品，并注明“来源:东盟矿业信息服务平台”，违者本网站将追究其相关法律责任。</p>
        <p>2、本网站凡注明“来源: XX（非东盟矿业信息服务平台）”的作品，均转载自其它媒体，东盟矿业信息服务平台登载此作品出于传递更多信息之目的，不代表东盟矿业信息服务平台观点或证实其描述，不对其真实性负责，作品内容仅供参考。</p>
        <p>3、本网站上会员注册及所发布信息的真实性、完整性和合法性由发布人自行负责。会员留言及评论仅代表使用本网站的该会员个人观点，本网站对此不承担任何保证责任。</p>
        <p>4、本网站本着客观和良善的原则，在力所能及的范围内，最大限度确保本网站所提供信息的准确性、完整性和及时性，但并不对任何信息的表述瑕疵或不确承担任何贵任。有关各方应谨慎参考操作，本网站概不就任何一方因参阅本网站信息而进行市场操作所带来的任何形式的损失承担任何责任。</p>
      </div>
      <div class="kslj">
        <h3>快速链接</h3>
        <ul class="links">
          <li><a href='http://www.mnr.gov.cn/' target="_blank"><img src='static/images/官网首页/fastlink/logo1.png' style="height: 45px;" /></a></li>
          <li><a href='http://www.gxzf.gov.cn/' target="_blank"><img src='static/images/官网首页/fastlink/logo2.png' style="height: 40px;" /></a></li>
          <li><a href='http://dnr.gxzf.gov.cn/' target="_blank"><img src='static/images/官网首页/fastlink/logo4.png' style="height: 37px;" /></a></li>
          <li><a href='http://www.cgs.gov.cn/' target="_blank"><img src='static/images/官网首页/fastlink/logo3.png' style="height: 52px;" /></a></li>
          <li><a href='http://www.caexpo.org/' target="_blank"><img src='static/images/官网首页/fastlink/logo6.png' style="height: 62px;" /></a></li>
          <li><a href='http://fgw.gxzf.gov.cn/' target="_blank"><img src='static/images/官网首页/fastlink/logo5.png' style="height: 42px;" /></a></li>
          <li><a href='http://dkj.gxzf.gov.cn/' target="_blank"><img src='static/images/官网首页/fastlink/logo7.png' style="height: 45px;" /></a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Wzsm.vue